import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from '../environments/environment';

// Absolute URLs (e.g. the OAuth /Token endpoint built from environment.apiUrl in AuthService) are already
// complete - prefixing them again produced ".../api/https://.../Token" in production.
const isAbsoluteUrl = (url: string): boolean => /^https?:\/\//i.test(url);

export const apiInterceptor = (request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
    if (
        !isAbsoluteUrl(request.url) &&
        request.url.includes('api') &&
        !request.url.includes('common') &&
        !request.url.includes('apps')
    ) {
        const baseUrl = environment.apiUrl;
        request = request.clone({ url: baseUrl + request.url });
    }

    return next(request).pipe(
        catchError((err, caught) => {
            console.error('API Error:', err);
            let message = 'An error occurred - Please contact support';

            if (err.error?.errors) {
                message = '';

                for (const key in err.error.errors)
                    for (const error of err.error.errors[key])
                        message += error + '\n';

                message = message.trim();
            } else if (err.error?.detail)
                message = err.error.detail;
            // OWIN's OAuth token endpoint (POST /Token) returns { error, error_description } on failure
            else if (err.error?.error_description)
                message = err.error.error_description;
            else if (typeof err.error === 'string' && err.error)
                message = err.error;

            return throwError(() => new Error(message));
        })
    );
};
